import { I18nManager } from "react-native";
import * as Commons from "./Commons";

export let STRINGS = "";

export const loadStrings = async () => {
  // const language = await Commons.getFromAS(Constants.language);
  // let { locale } = await Localization.getLocalizationAsync();
  // console.log(locale)
  // if (locale !== 'ar' && locale !== 'en'){
  //   locale = 'en'
  // }
  // locale = language == null ? locale : language;
  const locale = await Commons.language();

  const isArLtrOrEnRtl =
    (!I18nManager.isRTL && locale.startsWith("ar")) ||
    (I18nManager.isRTL && !locale.startsWith("ar"));
  if (locale.startsWith("en")) {
    STRINGS = {
      language: "en",
      services: 'Services',
      ok: "OK",
      okay: "OKAY",
      yes: "YES",
      yes_ol: "نعم",
      save: "SAVE",
      cancel: "CANCEL",
      cancel_ol: "الغاء",
      exit_app: "EXIT APP",
      jailbreak_warning_title: "SECURITY WARNING",
      jailbreak_warning_message: "This device appears to be jailbroken or rooted. For your account's security, the app cannot run on a compromised device.",
      exit_app_msg: "DO YOU WANT TO EXIT THE APP?",
      connection_error: "CONNECTION ERROR",
      cancel_order_msg: "DO YOU WANT TO CANCEL THIS ORDER?",
      try_again: "TRY AGAIN",
      fill_all_fields: "PLEASE FILL ALL FIELDS",
      menu: "MENU",
      loading: "LOADING ...",
      signup: "SIGN UP",
      // offline: 'YOU ARE OFFLINE',
      offline:
        "It seems you're out of town or offline! Please contact us on 0796200026 for assistance",
      time: "TIME:",
      back: "back",
      confirm: "CONFIRM",
      invalid_time: "INVALID TIME, PLEASE TRY AGAIN",
      delivery: "DELIVERY",
      delivery_info: "DELIVERY INFO",
      delivery_method: "DELIVERY METHOD",
      address: "Address",
      add: "ADD",
      enter_address: "Enter Address ...",
      phone_number: "PHONE NUMBER",
      phone_number_2: "Phone Number",
      enter_number: "ENTER NUMBER ...",
      number_of_children: "# Of Children",
      single: "SINGLE",
      married: "MARRIED",
      marital_status: "MARITAL STATUS",
      cancel_order: "CANCEL ORDER",
      select_delivery_time: "DELIVERY TIME",
      select_delivery_date: "DELIVERY DATE",
      please_select_delivery_date_location: "PLEASE SELECT DELIVERY LOCATION",
      note: "NOTE",
      address_note: "ADDRESS NOTE",
      add_address_note: "Add Address Note",
      my_order: "MY ORDER",
      item_name: "ITEM NAME",
      qty: "QTY",
      price: "PRICE",
      done: "DONE",
      change_location: "CHANGE LOCATION",
      click_the_map_to_add_your_address: "CLICK THE MAP TO ADD YOUR ADDRESS",
      discount: "DISCOUNT",
      tax: "TAX",
      total: "TOTAL",
      subtotal: "SUBTOTAL",
      hide: "HIDE",
      return: "RETURN",
      confirm_order: "PLACE ORDER",
      view_order: "VIEW ORDER",
      empty_basket_title: "YOUR BASKET IS EMPTY",
      edit: "Edit",
      delete: "DELETE",
      please_wait: "PLEASE WAIT",
      wrong_password: "WRONG PASSWORD",
      welcome_back: "Welcome Back",
      username_ph: "USERNAME",
      enter_your_email_and_password: "Enter your email and password:",
      username_or_email_or_mobile: " EMAIL OR MOBILE",
      password: "Password",
      login: "Login",
      forgot_password: "Forgot password?",
      register: "REGISTER",
      registration: "REGISTRATION",
      guest_user: "GUEST USER",
      whats_your_username: "WHAT IS YOUR EMAIL OR MOBILE?",
      enter_username: "ENTER username here ...",
      recover: "RECOVER",
      please_enter_username: "PLEASE ENTER YOUR USERNAME",
      recovery_email_sent:
        "A RECOVERY EMAIL HAS BEEN SENT TO YOU. PLEASE CHECK YOUR INBOX.",
      registration_step_1: "USER INFORMATION",
      registration_step_2: "CREATE ACCOUNT",
      first_name: "First Name",
      last_name: "Last Name",
      choose_gender: "CHOOSE GENDER",
      digits: "DIGITS",
      optional: "OPTIONAL",
      next: "NEXT",
      invalid_mobile_number: "PLEASE ENTER CORRECT MOBILE NUMBER",
      email_address: "Email",
      username: "Username",
      confirm_password: "Confirm Password",
      username_rules:
        "* USERNAME MUST NOT CONTAIN ANY SPACES AND BE AT LEAST 4 CHARACTERS LONG.",
      password_rules: "* PASSWORD MUST BE AT LEAST 4 CHARACTERS LONG.",
      invalid_email: "INVALID EMAIL",
      invalid_username: "INVALID USERNAME",
      invalid_password: "INVALID PASSWORD",
      invalid_phone: "INVALID MOBILE#",
      password_do_not_match: "PASSWORDS DO NOT MATCH",
      birthdate: "BIRTHDATE",
      choose_date: "CHOOSE DATE",
      mobile_number: "Phone Number",
      mobile_number_2: "2ND MOBILE",
      land_line: "LAND LINE",
      gender: "GENDER",
      male: "MALE",
      female: "FEMALE",
      email: "Email",
      submit_account: "SUBMIT",
      submit_account_update: "SUBMIT",
      search_items: "SEARCH ITEMS",
      search_data: "SEARCH",
      myorders: "MY ORDER HISTORY",
      order_sent_successfully: "Order sent successfully",
      order_id: "ORDER ID",
      active_order_id: "Active Order ID",
      order_summary: "ORDER SUMMARY",
      delivery_time: "DELIVERY TIME",
      delivery_date: "DELIVERY DATE",
      date: "DATE",
      profile: "PROFILE",
      name: "NAME",
      are_you_sure: "ARE YOU SURE?",
      update: "UPDATE",
      logout: "LOGOUT",
      reorder: "RE-ORDER",
      jd: "JD",
      edit_item: "EDIT ITEM",
      delete_item: "DELETE ITEM",
      offers: "HOME",
      featured_items: "FEATURED ITEMS",
      featured: "FEATURED",
      order_now: "ORDER NOW",
      show_menu: "Items",
      place_new_order: "PLACE NEW ORDER",
      place_new_order_capitals: "PLACE NEW ORDER",
      status: "STATUS",
      switchLanguage: "تغيير اللغة",
      switch_language_title: "اللغة",
      switch_language_msg: "تحويل الى اللغة العربية",
      callUs: "CALL US",
      shareApp: "SHARE APP",
      company_name: "MUJEB ORGANIC FARM",
      location_error: "COULD NOT GET YOUR LOCATION",
      enable_location_services: "PLEASE ENABLE LOCATION SERVICES.",
      location_permission_denied: "PERMISSION TO ACCESS LOCATION WAS DENIED",
      emulator_location_msg:
        "OOPS, THIS WILL NOT WORK ON SKETCH IN AN ANDROID EMULATOR. TRY IT ON YOUR DEVICE!",
      long_click_desc: "LONG CLICK ON MAP TO SELECT LOCATION",
      settings: "SETTINGS",
      news_info_title: "NEWS & INFORMATION",
      news_info_desc: "RECEIVE NEWS AND INFORMATION FROM MUJEB ORGANIC FARM",
      inv_by_mail_title: "E-MAIL INVOICE",
      inv_by_mail_desc: "SEND A COPY OF INVOICE BY EMAIL",
      reminder_title: "REMINDER",
      reminder_desc: "REMIND ME TO PLACE ORDERS",
      reminder_desc_notif:
        "Fresh produce has just been received from the field! Place your orders now",
      every_other_day: "EVERY OTHER DAY",
      every_week: "EVERY WEEK",
      custom_reminder: "CUSTOM",
      saturday: "SATURDAY",
      sunday: "SUNDAY",
      monday: "MONDAY",
      tuesday: "TUESDAY",
      wednesday: "WEDNESDAY",
      thursday: "THURSDAY",
      friday: "FRIDAY",
      apply: "APPLY",
      address_2: "2ND ADDRESS",
      delivery_step_0: "CHOOSE DELIVERY DATE & TIME",
      delivery_step_1: "",
      delivery_step_2: "CHOOSE DELIVERY ADDRESS & PHONE NUMBER",
      change: "Change",
      select_address: "SELECT ADDRESS",
      select_mobile: "SELECT MOBILE",
      write_a_review: "WRITE A REVIEW",
      post: "POST",
      checkout: "Checkout",
      privacy_policy: "Privacy Policy",
      cancel_and_refund_policy: "CANCEL AND REFUND POLICY",
      terms_of_service: "TERMS OF SERVICE",
      terms_of_delivery: "DELIVERY POLICY",
      terms_and_conditions: "TERMS AND CONDITIONS",
      curLanguage: locale,
      isArLtrOrEnRtl,
      invalid_day: "DELIVERIES ARE NOT AVAILABLE FRIDAYS AND SATURDAYS ",
      invalid_day_for_day: "DELIVERIES ARE NOT AVAILABLE ON ",
      addressUsage: "THIS IS THE DEFAULT DELIVERY LOCATION WHEN ORDERING",
      location_services: "LOCATION SERVICES",
      location_perpose:
        "THE APP REQUIRES LOCATION ACCESS TO GET THE CURRENT LOCATION TO USE IT AS THE DELIVERY LOCATION",
      new_at_mujeb: "New at Mujeb",
      cancel_not_allowed: "Not allowed",
      modify_order: "MODIFY",
      login_with_facebook: "LOGIN WITH FACEBOOK",
      login_here: "Login here",
      create_one_here: "Create one here",
      qty_is_not_available: "Quantity is not available",
      quantity: "QUANTITY",
      item_unavailable: "UNAVAILABLE",
      item_available: "AVAILABLE",
      notifications: "NOTIFICATIONS",
      organic: "MUJEB",
      non_organic: "PANTRY",
      category_3: "NURSERY",
      category_4: "TAMAM",
      select_invoice: "DELIVERY",
      refresh_list: "REFRESH",
      value: "VALUE",
      paid: "PAID",
      pay_method: "PAYMENT METHOD",
      completed: "DELIVERED",
      returned: "RETURNED",
      error_message: "ERROR",
      error_must_be_number: "VALUE MUST BE NUMBER",
      paid_value_unknown: "PAID VALUE MUST BE A NUMBER",
      method_unknown: "PAYMENT METHOD UNKNOWN",
      invoice_already_closed: "INVOICE IS CLOSED",
      already_have_account: "Already have an account? ",
      dont_have_account: "Don't have an account? ",
      customer: "CUSTOMER",
      invoice_count: "INVOICES",
      delivered: "DELIVERED",
      pending: "PENDING",
      location_not_found: "UNABLE TO FIND THE REQUESTED LOCATION",
      token: "OTP",
      wrong_otp_token: "INCORRECT OTP",
      mobile_verification: "MOBILE VERIFICATION",
      cash_on_delivery: 'CASH ON DELIVERY',
      visa_on_delivery: 'VISA ON DELIVERY',
      cliq_payment: "CLIQ (ALIAS: MUJEB)",
      online_payment: "PAY ONLINE",
      order_paid: "PAID ONLINE",
      paid_successfully: "PAID SUCCESSFULLY",
      payment_error: "PAYMENT ERROR",
      rate: "RATE",
      service_rating: "Service rating",
      product_rating: "Product rating",
      warning_max_images: "Warning max images reached",
      added: "Image added",
      add_image: "Add image",
      capture: "Capture",
      free_dlv_achieved: "Free delivery achieved",
      rem_free_dlv: "JDs left to get free delivery",
      rem_free_dlv0: "Almost there! ",
      pay_now: "PAY ONLINE",
      select_customer: "SELECT CUSTOMER",
      gift: "GIFT",
      recipient: "RECIPIENT",
      city: "City",
      delivery_only_amman: "Delivery only available in Amman",
      not_enought_qty: "QUANTITY UNAVAILABLE",
      gift_note:
        "GIFTS MUST BE PAID ONLINE PRIOR TO DELIVERY\n\nALL ORDERS PLACED BEFORE 6PM WILL BE DELIVERED THE DAY AFTER",
      recipient_info_error: "RECIPIENT NAME OR MOBILE ARE NOT SET",
      no_orders_message: "NO ITEMS ADDED TO YOUR BASKET",
      gift_to: "GIFT TO",
      promo_code: "PROMO CODE",
      delivery_charge: "DELIVERY",
      shopping_cart: "SHOPPING CART",
      all_products_img: "SHOP\nALL\nPRODUCTS",
      all_products: "ALL PRODUCTS",
      products: "Products",
      filter_and_sort: "FILTERS AND SORTING",
      availability: "AVAILABILITY",
      product_type: "PRODUCT TYPE",
      sort_by: "SORT BY",
      sort_by_options: [
        { label: "DEFAULT", value: "1" },
        { label: "PRICE HIGHER \u2191", value: "2" },
        { label: "PRICE LOWER \u2193", value: "3" },
      ],
      default: "DEFAULT",
      price_high_to_low: "PRICE HIGH TO LOW",
      price_low_to_high: "PRICE LOW TO HIGH",
      added_to_cart: "ITEM ADDED TO CART",
      from: "FROM",
      to: "TO",
      currency: "JD",
      brand: "BRAND",
      certificate: "CCPB ORGANIC CERTIFICATION",
      categories: "CATEGORIES",
      navigate_to_location: "NAVIGATE TO LOCATION",
      items_notes:
        "Our produce is seasonal and available items change every day. Check back daily to see what's new!",
      dlv_time_note:
        "Note: orders placed after 4 PM are delivered the following day",
      how_it_works: "HOW IT WORKS",
      how_to_use_the_app: "HOW TO USE THE APP",
      credit: "CREDIT",
      confirm_new_password: "CONFIRM NEW PASSWORD",
      back_to_home_page: "BACK TO HOME PAGE",
      your_account: "YOUR ACCOUNT",
      order_history: "ORDER HISTORY",
      account_details: "ACCOUNT DETAILS",
      change_password: "CHANGE PASSWORD",
      new_password: "NEW PASSWORD",
      old_password: "OLD PASSWORD",
      edit_information: "EDIT INFORMATION",
      shop: "SHOP",
      our_nursery: "OUR NURSERY",
      about_us: "About Us",
      contact_us: "Contact Us",
      all: "ALL",
      back_to_shopping_cart: "BACK TO SHOPPING CART",
      back_to_shop_page: "BACK TO SHOP PAGE",
      err_mobile_already_used: 'THIS MOBILE NUMBER IS ALREADY IN USE',
      err_email_already_used: 'THIS EMAIL IS ALREADY IN USE',
      err_username_already_used: 'THIS USERNAME IS ALREADY IN USE',
      careers: 'Careers',
      pharmacovigilance: 'Pharmacovigilance',
      our_core_value: 'Our Core Values',
      make_deferent_with_us: 'Make A Difference With Us',
      our_history: 'Our History',
      Ethics_and_Integrity: 'We are committed to the utmost standards of ethics and integrity\nacross all facets of our business, fostering transparency and\ntrustworthiness, as exemplified by our robust Code of Ethics.',
      Competence: 'We are committed to continuous investment in knowledge and\nskills, fostering competence and excellence among our team\nmembers through training, lectures, and a supportive\nlearning environment.',
      Respect_and_Diversity: 'We celebrate diversity and extend respect to all through upholding\nan inclusive workplace where every employee feels respected\nand valued.',
      Quality_and_Compliance: 'Jordan Drugstore is committed to maintaining the highest\nstandards of quality. We prioritize all stakeholders satisfaction\nthrough the dedicated efforts of our quality-conscious staff,\ncompliance with regulations, and fostering a safe\nwork environment.',
      Reliability: 'Reliability is the cornerstone of our services. We consistently\ndeliver, ensuring the dependable supply of healthcare products,\ntimely delivery, and partnerships.',
      Sustainability: 'JDS values social sustainability, fostered by our proactive Social\nCommittee. We prioritize settings and achieving environmental\ngoals to minimize our impact and contribute positively to\nour community and the environment.',
      Account_Number: 'Account Number',
      Your_Account_Number: 'Your Account Number',
      Your_Phone_Number: 'Your Phone Number',
      Activate_Account_Number: "Activate with your account number",
      Activate_your_Account: "Activate Your Account",
      Download_online_account_activation: "Download online account activation agreement",
      Choose_file: 'Choose File',
      Upload: 'Upload',
      choose_file_source_message: 'How would you like to add your document?',
      Take_Photo: 'Take Photo',
      Choose_from_Files: 'Choose from Files',
      camera_permission_required_title: 'Camera Permission Required',
      camera_permission_required_message: 'Please allow camera access to take a photo of your document.',
      camera_unavailable_message: 'Unable to open the camera. Please try again.',
      OTP_Code_Verification: 'OTP Code Verification',
      Verification_Phone_number: 'A verification code has been sent to the phone number \n +962 7X XXX XXXX linked to your account.',
      Otp_Error_Message: 'Incorrect code. Please try again',
      Resend_Code: 'Resend Code',
      Resending_Otp: 'Resending the OTP is enabled every 30 \n seconds for 3 times',
      Too_Many_Failed_Attempts: 'Too Many Failed Attempts',
      Too_Many_Failed_Attempts_Message: 'You can no longer login due to too many incorrect OTP attempts.\n For your security, please try again later or contact\n our call center.',
      Due_Balance: 'Due Balance',
      Statement_of_Account: 'Statement of \nAccount',
      Statement_of_Account_Desktop: 'Statement of Account',
      Invoice_Returns: 'Invoices & \nReturns',
      Invoice_Returns_Desktop: 'Invoices & Returns',
      Orders: 'My Orders',
      Active_Orders: 'Active Orders',
      All_Orders: 'All Orders',
      Balance: 'Balance',
      Total_Debit: 'Total Debit',
      Total_Credit: 'Total Credit',
      Transaction: 'Transactions',
      Invoice_Details: 'Invoice Details',
      Tax_invoice: 'Tax: ',
      Total_invoice: 'Total: ',
      Invoices: 'Invoices',
      Returns: 'Returns',
      Total_Amount: 'Total Amount',
      January: 'January',
      February: 'February',
      March: 'March',
      April: 'April',
      May: 'May',
      June: 'June',
      July: 'July',
      August: 'August',
      September: 'September',
      October: 'October',
      November: 'November',
      December: 'December',
      Order_Timeline: 'Order Timeline',
      Item: 'Item',
      Qty_Details: 'Qty',
      Price_Details: 'Price',
      Expiry: 'Expiry',
      Batch: 'Batch',
      Order_Details: 'Order Details',
      order_date: 'Order Date',
      estimated_delivery: 'Estimated Delivery',
      awaiting_restock: 'Awaiting Restock',
      Account_Details_Profile: 'Account Details',
      Registered_Phone_Number: 'Registered Phone Number',
      Profile_Address: 'Address',
      Authorized_Signee: 'Authorized Signee ',
      updating_Account_Details: 'Updating Account Details',
      Updating_Account_Text: 'Updating account information is currently unavailable\nthrough the app to ensure your security. To update your\ndetails, please contact our call center. Our team is ready to\nassist you.',
      Updating_Account_Text_Desktop: 'Updating account information is currently unavailable through the app to ensure your security. To update your details, please contact our call center. Our team is ready to assist you.',
      from: 'From',
      to: 'To',
      Request: 'Request',
      Invoices_Returns: 'Invoices & Returns',
      Statement_Account: 'Statement of Account',
      Return_Details: 'Return Details',
      discount_2: 'Discount',
      activation_paragraph: 'To send an account activation request, please enter your account number, download the activation agreement, sign and stamp it, then upload the signed document as a PDF or JPG to complete your request.',
      activation_error_message: 'Unable to process request.',
      activation_enter_account_number: 'Please enter your account number.',
      profile_log_out: 'Logout',
      profile_Desktop: 'Profile',
      logout_Desktop: 'Logout',
      Download_Button: 'Download',
      Date_desktop: 'Date',
      Type: 'Type',
      Transaction_No: 'Transaction #',
      Description: 'Description',
      Debit: 'Debit',
      Credit: 'Credit',
      Balance: 'Total Balance',
      Order_Desktop: 'Order #',
      est_delivery: 'Est. Delivery',
      order_value: 'Order Value',
      order_status: 'Status',
      Desktop_Invoices: 'Invoices',
      Desktop_Returns: 'Returns',
      Desktop_Item_Name: 'Item Name',
      Desktop_Price: 'Price',
      Desktop_Expiry: 'Expiry',
      Desktop_Batch: 'Batch',
      Desktop_Tax: 'Tax',
      Desktop_Total: 'Total',
      Desktop_invoice_number: 'Invoice #',
      Date_desktop_date: 'Invoice Date',
      Desktop_return_number: 'Return #',
      Desktop_return_date: 'Return Date',
      Norm_Order: 'Order',
      estimate_delivery: 'Estimate Delivery',
      Transaction_Type: 'Transaction Type',
      Notes: 'Notes',
      Return_Desktop: 'Returns Details',
      pahrmacy_name: 'Pharmacy name',
      Assigned_Sales_Rep: 'Assigned Sales Rep',
      Sales_Rep_Phone: 'Sales Rep Phone Number',
      appCategories: 'Categories',
      appOffers: 'Offers',
      appFeatured: 'Featured Items',
      app_Brands: 'Consumer Brands',
      app_Best_Sellers: 'Best Sellers',
      app_Home: 'Home',
      app_Order_Now: 'Order Now',
      app_My_Account: 'My Account',
      app_Other: 'Other',
      product_name: 'Product Name',
      pharmacy_name: 'Pharmacy Name',
      pharmacy_price: 'Pharmacy Price',
      Sales_Tax: 'Sales Tax',
      Public_Price: 'Public Price',
      Expiry_Date: 'Expiry Date',
      Bonus: 'Bonus',
      filters: 'Filters',
      Applied_Filters: 'Applied',
      pharmaceutical_Brands: 'Pharmaceutical Brands',
      clear_Filters: 'Clear Filters',
      view_filters: 'View',
      items_filters: 'Items',
      plus_tax: '(+16% tax)',
      add_to_cart: 'Add to Cart',
      checkOut_cart: 'Cart',
      checkOut_Delevery: 'Delivery',
      checkOut_Expected_by: 'Estimated by',
      checkOut_Payment_Terms: 'Payment Terms',
      checkOut_Subtotal: 'Subtotal',
      checkOut_Discount: 'Discount',
      checkOut_Tax: 'Tax',
      checkOut_Estimated_Total: 'Estimated Total',
      checkOut_Place_Order: 'Place Order',
      products_Items: 'Items',
      app_notifications: 'Notifications',
      app_notifications_settings: 'Notifications Settings',
      turn_on_notifications: 'Turn on notifications',
      notifications_type: 'Notifications Types',
      notify_whatsapp: 'WhatsApp Notifications',
      notify_app: 'App Notifications',
      order_notification_Related: 'Order Related Notifications',
      order_notification_Related_description: 'Order status updates, returns & invoices, profile or account changes',
      product_stock_notification: 'Product & Stock Notifications',
      product_stock_notification_description: 'Back-in-stock alerts and new product launches alerts ',
      promotions_Bonuses_notification: 'Promotions & Bonuses Notifications',
      promotions_Bonuses_notification_description: 'Bonus offers and deals',
      account_documents_notification: 'Account & Documents Notifications',
      account_documents_notification_description: 'Bonus offers and deals',
      critical_alert: 'Critical Alert',
      clitical_alert_description: 'Recalling product, account issues, and payment reminders',
      order_confirmation: 'Order Confirmation',
      item_back_in_stock: 'Item Back in Stock',
      limited_time_bonus_offers: 'Limited Time Bonus Offers',
      app_Best_Sellers: 'Best Sellers',
      shop_home: 'Home',
      shop_screen: 'Shop',
      shop_order: 'Order',
      account_onHold: 'Your account is on hold',
      sales_rep: 'Contact Sales Rep',
      acc_hold_message: 'Your orders will not be shipped or processed. Please contact your sales rep.',
      cancel_order: 'Cancel Order',
      cancel_order_msg: 'You’ve requested to cancel your order',
      cancel_Question: 'Are you sure you want to cancel?',
      shop_by_brand: 'Shop by Brand',
      view_all: 'View all',
      shop_by_category: 'Shop by Category',
      desktop_cart: 'Cart',
      apply_filters: 'Apply Filters',
      clear_checkOut: 'Clear',
      button_invoice: 'Invoice',
      cancel_order_failed: 'Failed to cancel order',
      qty_limit_reached: 'Quantity Limit Reached',
      notes: 'Notes',
    };
  } else {
    STRINGS = {
      language: "ar",
      services: 'الخدمات',
      ok: "موافق",
      okay: "موافق",
      yes: "نعم",
      yes_ol: "Yes",
      save: "حفظ",
      cancel: "الغاء",
      cancel_ol: "CANCEL",
      exit_app: "خروج",
      jailbreak_warning_title: "تحذير أمني",
      jailbreak_warning_message: "يبدو أن هذا الجهاز مُخترق (Jailbreak/Root). لأمان حسابك، لا يمكن تشغيل التطبيق على جهاز غير آمن.",
      exit_app_msg: "هل تريد الخروج من التطبيق؟",
      connection_error: "خطأ بالاتصال",
      cancel_order_msg: "هل تريد الخروج من الطلب?",
      try_again: "إعادة المحاولة",
      fill_all_fields: "الرجاء إدخال جميع البيانات",
      menu: "القائمة الرئيسية",
      loading: "الرجاء الانتظار",
      // offline: 'انت غير متصل بالانترنت',
      offline:
        "يظهر انكم خارج البلد او غير متصلين على شبكة النت الرجاء التواصل معنا على ٠٧٩٦٢٠٠٠٢٦",
      time: "الوقت:",
      back: "رجوع",
      confirm: "موافق",
      invalid_time: "وقت غير متاح٬ الرجاء المحاولة مرة اخرى",
      delivery: "خدمة التوصيل",
      delivery_info: "معلومات التوصيل",
      delivery_method: "طريقة التوصيل",
      address: "العنوان",
      add: "اضافة",
      enter_address: "ادخل العنوان ...",
      phone_number: "رقم الهاتف",
      enter_number: "ادخل رقم الهاتف ...",
      number_of_children: "عدد الأطفال",
      single: "أعزب",
      married: "متزوج",
      marital_status: "الحالة الإجتماعية",
      cancel_order: "الغاء الطلب",
      select_delivery_time: " وقت توصيل الطلب",
      select_delivery_date: " تاريخ توصيل الطلب",
      please_select_delivery_date_location: " وقت ومكان التوصيل",
      date: "التاريخ:",
      note: "ملاحظة",
      address_note: "ملاحظة الموقع",
      add_address_note: "اضافة ملاحظة الموقع",
      my_order: "طلبي",
      item_name: "المادة",
      qty: "الكمية",
      price: "السعر",
      done: "موافق",
      change_location: "تغيير الموقع",
      discount: "خصم",
      tax: "ضريبة",
      total: "المجموع",
      subtotal: "المجموع الفرعي",
      hide: "اخفاء",
      return: "رجوع",
      confirm_order: "ارسال الطلب",
      view_order: "عرض الطلب",
      empty_basket_title: "السلة فارغة",
      edit: "تعديل",
      delete: "حذف",
      please_wait: "الرجاء الانتظار",
      wrong_password: "كلمة المرور غير صحيحة",
      welcome_back: "اهلا بك",
      username_ph: "اسم المستخدم",
      enter_your_email_and_password: ":ادخل البريد الالكتروني وكلمة المرور",
      password: "كلمة المرور",
      login: "تسجيل الدخول",
      forgot_password: "نسيت كلمة المرور؟",
      register: "انشاء حساب جديد",
      registration: "انشاء حساب",
      guest_user: "مستخدم زائر",
      whats_your_username: "ما هو اسم المستخدم ,الايميل او الهاتف الخاص بك؟",
      enter_username: "ادخل اسم المستخدم ...",
      recover: "استرجاع",
      please_enter_username: "الرجاء ادخال اسم المستخدم",
      recovery_email_sent:
        "تم ارسال بريد الكتروني لاسترجاع كلمة المرور الخاصة بحسابك. الرجاء مراجعة بريدك الالكتروني.",
      registration_step_1: "معلومات المستخدم",
      registration_step_2: "انشاء حساب",
      first_name: "الاسم الاول",
      last_name: "اسم العائلة",
      choose_gender: "اختر الجنس",
      digits: "ارقام",
      optional: "اختياري",
      next: "التالي",
      invalid_mobile_number: "رقم الموبايل غير صحيح",
      email_address: "البريد الالكتروني",
      username: "اسم المستخدم",
      confirm_password: "تاكيد كلمة المرور",
      username_rules:
        "* يجب ان لا يحتوي اسم المستخدم على اي فراغات٬ وان لا يقل عن 4 حروف.",
      password_rules: "* يجب أن لا تقل كلمة المرور عن ٤ حروف",
      invalid_email: "البريد الالكتروني غير صحيح",
      invalid_username: "اسم المستخدم غير صحيح",
      invalid_password: "كلمة المرور غير صحيحة",
      invalid_phone: "رقم الهاتف غير صحيح",
      password_do_not_match: "كلمة المرور غير مطابقة",
      birthdate: "تاريخ الميلاد",
      choose_date: "اختر تاريخاً",
      mobile_number: "رقم الموبايل",
      mobile_number_2: "موبايل آخر",
      land_line: "رقم ارضي",
      gender: "الجنس",
      male: "ذكر",
      female: "انثى",
      email: "البريد الاكتروني",
      submit_account: "انشاء حساب",
      submit_account_update: "حفظ",
      search_items: "بحث عن منتج",
      myorders: "طلباتي",
      order_sent_successfully: "تم ارسال الطلب بنجاح",
      order_id: "رقم الطلب",
      order_summary: "ملخص الطلب",
      delivery_time: "تاريخ الطلب",
      delivery_date: "تاريخ التوصيل",
      profile: "ملفي الشخصي",
      name: "الاسم",
      are_you_sure: "هل انت متاكد؟",
      update: "تعديل",
      logout: "تسجيل الخروج",
      reorder: "طلب مرة اخرى",
      jd: "JD",
      edit_item: "تعديل الطلب",
      delete_item: "حذف المادة",
      offers: "الرئيسية",
      featured_items: "مواد مختارة",
      featured: "مواد مختارة",
      order_now: "اطلب الان",
      show_menu: "عرض المواد",
      place_new_order: "عمل طلب جديد",
      place_new_order_capitals: "عمل طلب جديد",
      status: "الحالة",
      switchLanguage: "SWITCH LANGUAGE",
      switch_language_title: "Language",
      switch_language_msg: "Switch language to English?",
      callUs: " اتصل بنا",
      shareApp: "مشاركة البرنامج",
      company_name: "الموجب للزراعة العضوية",
      location_error: "لم نستطع تحديد موقعك",
      enable_location_services: "الرجاء تفعيل خدمات الموقع",
      location_permission_denied: "لم يتم السماح للتطبيق باستخدام خدمات الموقع",
      emulator_location_msg:
        "aOops, this will not work on Sketch in an Android emulator. Try it on your device!",
      long_click_desc: "اضغط ضغطة مطولة على الخريطة لاختيار الموقع",
      settings: "الإعدادات",
      news_info_title: "أخبار ومعلومات",
      news_info_desc: "تلقي الأخبار والمعلومات من للزراعة العضوية الموجب",
      inv_by_mail_title: "نسخة عن الفاتورة",
      inv_by_mail_desc: "إرسال نسخة من الفاتورة عبر البريد الإلكتروني",
      reminder_title: "تذكير",
      reminder_desc: "تذكير بعمل طلب جديد",
      reminder_desc_notif: "وصلتنا قطفة جديدة, ما تنسو تطلبو منها لتوصلكم بكرة",
      every_other_day: "يوم بعد يوم",
      every_week: "كل اسبوع",
      custom_reminder: "اختيار الأيام",
      saturday: "السبت",
      sunday: "الأحد",
      monday: "الإثنين",
      tuesday: "الثلاثاء",
      wednesday: "الأربعاء",
      thursday: "الخميس",
      friday: "الجمعة",
      apply: "تطبيق",
      address_2: "عنوان آخر",
      delivery_step_0: "اختر تاريخ ووقت التسليم",
      delivery_step_1: "",
      delivery_step_2: "اختر عنوان التسليم ورقم الهاتف",
      change: "تغيير",
      select_address: "اختر عنوانا",
      select_mobile: "اختر رقم الهاتف",
      write_a_review: "ملاحظات",
      post: "إضافة",
      checkout: "تأكيد الطلب",
      privacy_policy: "سياسة الخصوصية",
      terms_and_conditions: "الأحكام والشروط",
      cancel_and_refund_policy: "سياسة الإلغاء والاسترداد",
      terms_of_service: "شروط الخدمة",
      terms_of_delivery: "شروط التوصيل",
      curLanguage: locale,
      isArLtrOrEnRtl,
      invalid_day: "لا يوجد توصيل ايام الجمعة و السبت",
      invalid_day_for_day: " لا يوجد توصيل لتاريخ ",
      addressUsage: "الموقع يستخدم كموقع التسليم المعتاد",
      location_services: "خدمات الموقع",
      location_perpose:
        "البرنامج بحاجة لأذن خدمات الموقع ليتمكن من تحديد الموقع الحالي لوضعه كموقع للتوصيل ",
      new_at_mujeb: "جديد في الموجب",
      cancel_not_allowed: "غير مسموح ",
      modify_order: "تعديل",
      login_with_facebook: "تسجيل الدخول باستخدام الفيسبوك",
      login_here: "تسجيل دخول",
      create_one_here: "انشاء حساب",
      qty_is_not_available: "الكمية غير متوفرة",
      quantity: "الكمية",
      item_unavailable: "غير متوفر",
      item_available: "متوفر",
      notifications: "الاشعارات",
      organic: "موجب",
      non_organic: "المونة",
      category_3: "مشتل",
      category_4: "تمام",
      username_or_email_or_mobile: "اسم المستخدم ,الايميل او الهاتف",
      refresh_list: "تحديث",
      search_data: "بحث",
      value: "القيمة",
      paid: "دفع",
      pay_method: "طريقة الدفع",
      completed: "تم التسليم",
      returned: "مرتجع",
      error_message: "تنبيه",
      error_must_be_number: "يجب أن تكون القيمة رقمًا",
      paid_value_unknown: "المبلغ المدفوع غير معرف",
      method_unknown: "طريقة الدفع غير معرف",
      invoice_already_closed: "تم إغلاق الفاتورة",
      already_have_account: " لديك حساب؟ ",
      dont_have_account: " ليس لديك حساب؟ ",
      customer: "العميل",
      select_invoice: "التوصيل",
      invoice_count: "الفواتير",
      delivered: "تم التوصيل",
      pending_count: "معلق",
      location_not_found: "الموقع المطلوب غير معرف",
      token: "كلمة المرور",
      wrong_otp_token: "كلمة المرور غير صحيحة",
      mobile_verification: "التحقق من رقم الموبايل",
      cash_on_delivery: "نقدا مع التوصيل",
      visa_on_delivery: 'فيزا عند التوصيل',
      cliq_payment: "CLIQ (ALIAS: MUJEB)",
      order_paid: "مدفوع",
      paid_successfully: "تمت عملية الدفع بنجاح",
      payment_error: "لم تتم عملية الدفع",
      rate: "تقييم",
      service_rating: "تقييم الخدمة",
      product_rating: "تقييم المنتج",
      warning_max_images: "تم الوصول إلى أقصى حد للصور",
      added: "تمت إضافة الصورة",
      add_image: "اضافة صورة",
      capture: "التقاط صورة",
      free_dlv_achieved: "تم تحقيق التوصيل المجاني",
      rem_free_dlv: "دينار حتى تحقيق التوصيل المجاني",
      rem_free_dlv0: "",
      online_payment: "الدفع الالكتروني",
      pay_now: "ادفع الان",
      select_customer: "اختيار العميل",
      gift: "هدية",
      recipient: "المستلم",
      city: "المدينة",
      not_enought_qty: "كمية غير متوفرة",
      gift_note:
        "يجب دفع الطلب عن طريق الدفع الإلكتروني عند توضيب الطلبية وقبل التوصيل\n\nيتم إستلام طلبيات الهدايا قبل الساعة السادسة ليتم توصيلها في اليوم التالي",
      recipient_info_error: "اسم المستلم و رقم الهاتف غير معرف",
      no_orders_message: "لم يتم العثور على طلبات",
      gift_to: "هدية الى",
      promo_code: "رمز الترويج",
      delivery_charge: "التوصيل",
      shopping_cart: "سلة الشراء",
      all_products_img: "تسوق\nجميع\nالمنتجات",
      all_products: "جميع المنتجات",
      products: "المواد",
      filter_and_sort: "التصفية والفرز",
      availability: "التواجد",
      product_type: "نوع المنتج",
      sort_by: "ترتيب حسب",
      sort_by_options: [
        { label: "افتراضي", value: "1" },
        { label: "السعر الاعلى \u2191", value: "2" },
        { label: "السعر الاقل \u2193", value: "3" },
      ],
      default: "افتراضي",
      price_high_to_low: "السعر الاعلى الى الادنى",
      price_low_to_high: "السعر الادنى الى الاعلى",
      added_to_cart: "مضاف الى السلة",
      from: "من",
      to: "الى",
      currency: "د.ا",
      brand: "الماركة",
      certificate: "\u200Eالشهادة العضوية من\u200E CCPB",
      categories: "مجموعات",
      navigate_to_location: "الذهاب الى الموقع",
      items_notes:
        "أصنافنا موسمية وتتغير بشكل يومي حسب الحصاد. تصفحوا التطبيق كل يوم لتتسوقوا الأصناف الجديدة!",
      dlv_time_note:
        "ملاحظة : الطلبيات التي تطلب بعد الساعة الرابعة يتم توصيلها اليوم التالي",
      how_it_works: "طريقة الاستعمال",
      how_to_use_the_app: "طريقة استعمال البرنامج",
      credit: "رصيد سابق",
      signup: "اشتراك",
      delivery_only_amman: "التوصيل فقط داخل عمان",
      confirm_new_password: "تأكيد كلمة السر الجديدة",
      back_to_home_page: "العودة إلى الصفحة الرئيسية",
      your_account: "الحساب الخاص بك",
      order_history: "طلباتك السابقة",
      account_details: "تفاصيل الحساب",
      change_password: "تغيير كلمة المرور",
      new_password: "كلمة المرور الجديدة",
      old_password: "كلمة المرور القديمة",
      edit_information: "تعديل المعلومات",
      shop: "تسوق",
      our_nursery: "المشتل",
      about_us: "معلومات عنا",
      contact_us: "اتصل بنا",
      all: "الكل",
      click_the_map_to_add_your_address: "انقر على الخريطة لإضافة عنوانك",
      back_to_shopping_cart: "الرجوع إلى عربة التسوق",
      back_to_shop_page: "العودة إلى صفحة المتجر",
      err_mobile_already_used: 'رقم الهاتف المطلوب مستخدم مسبقا',
      err_email_already_used: 'الايميل المطلوب مستخدم مسبقا',
      err_username_already_used: 'اسم المستخدم المطلوب مستخدم مسبقا',
      careers: 'وظائف',
      pharmacovigilance: 'اليقظة الدوائية',
      make_deferent_with_us: 'اصنع فرقا معنا',
      our_history: 'تاريخنا',
      Account_Number: 'رقم الحساب',
      Your_Account_Number: 'رقم حسابك',
      Your_Phone_Number: 'رقم الهاتف',
      phone_number_2: 'رقم الهاتف ',
      Activate_Account_Number: "تفعيل برقم الحساب",
      Activate_your_Account: "تفعيل حسابك",
      Download_online_account_activation: "تحميل اتفاقية تفعيل الحساب عبر الانترنت",
      Choose_file: 'اختر ملف',
      Upload: 'تحميل',
      choose_file_source_message: 'كيف تريد إضافة المستند؟',
      Take_Photo: 'التقاط صورة',
      Choose_from_Files: 'الاختيار من الملفات',
      camera_permission_required_title: 'مطلوب إذن الكاميرا',
      camera_permission_required_message: 'يرجى السماح بالوصول إلى الكاميرا لالتقاط صورة للمستند.',
      camera_unavailable_message: 'تعذر فتح الكاميرا. الرجاء المحاولة مرة أخرى.',
      OTP_Code_Verification: 'التحقق من رمز OTP',
      Verification_Phone_number: 'تم ارسال رمز التحقق الى رقم الهاتف \n +962 7X XXX XXXX المرتبط بحسابك.',
      Otp_Error_Message: 'الرمز غير صحيح. الرجاء المحاولة مرة اخرى',
      Resend_Code: 'اعادة ارسال الرمز',
      Resending_Otp: 'اعادة ارسال الرمز متاحة كل 30 \n ثانية لمرتين',
      Too_Many_Failed_Attempts: 'الكثير من المحاولات الفاشلة',
      Too_Many_Failed_Attempts_Message: 'لا يمكنك تسجيل الدخول بسبب العديد من محاولات OTP غير الصحيحة.\n لأمانك، يرجى المحاولة مرة أخرى لاحقًا أو الاتصال\n بمركز الاتصال الخاص بنا.',
      Due_Balance: 'الرصيد المستحق',
      Statement_of_Account: 'كشف حساب',
      Invoice_Returns: 'الفواتير والإرجاعات',
      Orders: 'طلبياتي',
      Active_Orders: 'الطلبات النشطة',
      All_Orders: 'جميع الطلبات',
      Balance: 'رصيد الحساب',
      Total_Debit: 'إجمالي الدين',
      Total_Credit: 'إجمالي الائتمان',
      Transaction: 'المعاملات',
      Invoice_Details: 'تفاصيل الفاتورة',
      Tax_invoice: ':الضريبة',
      Total_invoice: ':المجموع',
      Invoices: 'الفواتير',
      Returns: 'المرتجعات',
      Total_Amount: 'المبلغ الإجمالي',
      January: 'يناير ',
      February: 'فبراير ',
      March: 'مارس ',
      April: 'أبريل ',
      May: 'مايو ',
      June: 'يونيو ',
      July: 'يوليو ',
      August: 'أغسطس ',
      September: 'سبتمبر ',
      October: 'أكتوبر ',
      November: 'نوفمبر ',
      December: 'ديسمبر ',
      Order_Timeline: 'ترتيب الجدول الزمني',
      Item: 'المادة',
      Qty_Details: 'الكمية',
      Price_Details: 'السعر',
      Expiry: 'انتهاء الصلاحية',
      Batch: 'حزمة',
      Order_Details: 'تفاصيل الطلب',
      Account_Details_Profile: 'تفاصيل الحساب',
      Registered_Phone_Number: 'رقم الهاتف المسجل',
      Profile_Address: 'العنوان',
      Authorized_Signee: 'الموقع المعتمد',
      updating_Account_Details: 'تحديث تفاصيل الحساب',
      Updating_Account_Text: 'تحديث معلومات الحساب غير متاح حاليًا\nمن خلال التطبيق لضمان أمنك. لتحديث بياناتك\nالتفاصيل، يرجى الاتصال بمركز الاتصال لدينا. فريقنا جاهز\nassist you.',
      from: 'من',
      to: 'إلى',
      Request: 'طلب',
      Invoices_Returns: 'الفواتير والمرتجعات',
      Statement_Account: 'كشف حساب',
      Return_Details: 'تفاصيل المرتجع',
      discount_2: 'خصم',
      activation_paragraph: 'لإرسال طلب تفعيل الحساب، يرجى إدخال رقم حسابك، وتنزيل اتفاقية التنشيط، وتوقيعها وختمها، ثم تحميل الوثيقة الموقعة بصيغة PDF أو JPG لإكمال طلبك.',
      activation_error_message: 'تعذر معالجة الطلب.',
      activation_enter_account_number: 'الرجاء إدخال رقم الحساب.',
      profile_log_out: 'تسجيل الخروج',
      Statement_of_Account_Desktop: 'كشف حساب',
      Invoice_Returns_Desktop: 'الفواتير والإرجاعات',
      profile_Desktop: 'الملف الشخصي',
      logout_Desktop: 'تسجيل الخروج',
      Download_Button: 'تحميل',
      Date_desktop: 'التاريخ',
      Type: 'النوع',
      Transaction_No: 'رقم المعاملة',
      Description: 'الوصف',
      Debit: 'الدين',
      Credit: 'الائتمان',
      Balance: 'الرصيد',
      Order_Desktop: 'الطلب #',
      est_delivery: 'التسليم المتوقع',
      order_value: 'قيمة الطلب',
      order_status: 'الحالة',
      Desktop_Invoices: 'الفواتير',
      Desktop_Returns: 'المرتجعات',
      Desktop_Item_Name: 'اسم المادة',
      Desktop_Price: 'السعر',
      Desktop_Expiry: 'انتهاء الصلاحية',
      Desktop_Batch: 'حزمة',
      Desktop_Tax: 'الضريبة',
      Desktop_Total: 'المجموع',
      Desktop_invoice_number: 'رقم الفاتورة',
      Desktop_return_number: 'رقم المرتجع',
      Desktop_return_date: 'تاريخ المرتجع',
      Norm_Order: 'الطلب',
      estimate_delivery: 'التسليم المتوقع',
      Transaction_Type: 'نوع المعاملة',
      Notes: 'ملاحظات',
      Date_desktop_date: 'تاريخ الفاتورة',
      Return_Desktop: 'تفاصيل المرتجع',
      pahrmacy_name: 'اسم الصيدلية',
      Updating_Account_Text_Desktop: 'تحديث معلومات الحساب غير متاح حاليًا من خلال التطبيق لضمان أمانك. لتحديث بياناتك التفاصيل، يرجى الاتصال بمركز الاتصال لدينا. فريقنا جاهز assist you.',
      Assigned_Sales_Rep: 'مندوب المبيعات المعين',
      Sales_Rep_Phone: 'رقم هاتف مندوب المبيعات',
      appCategories: 'الفئات',
      appOffers: 'العروض',
      appFeatured: 'العناصر المميزة',
      app_Brands: 'ماركات المستهلك',
      app_Best_Sellers: 'الأكثر مبيعًا',
      app_Home: 'الرئيسية',
      app_Order_Now: 'اطلب الآن',
      app_My_Account: 'حسابي',
      app_Other: 'أخرى',
      product_name: 'اسم المنتج',
      pharmacy_name: 'اسم الصيدلية',
      Sales_Tax: 'الضريبة',
      Public_Price: 'السعر العام',
      Expiry_Date: 'تاريخ انتهاء الصلاحية',
      Bonus: 'المكافأة',
      pharmacy_price: 'سعر الصيدلية',
      filters: 'المرشحات',
      Applied_Filters: 'المرشحات المطبقة',
      pharmaceutical_Brands: 'ماركات الأدوية',
      view_filters: 'عرض',
      clear_Filters: 'مسح المرشحات',
      items_filters: 'العناصر',
      plus_tax: '(+16% ضريبة)',
      add_to_cart: 'أضف إلى السلة',
      checkOut_cart: 'السلة',
      checkOut_Delevery: 'التوصيل',
      checkOut_Expected_by: 'متوقع بحلول',
      checkOut_Payment_Terms: 'شروط الدفع',
      checkOut_Subtotal: 'المجموع الفرعي',
      checkOut_Discount: 'الخصم',
      checkOut_Tax: 'الضريبة',
      checkOut_Estimated_Total: 'المجموع التقديري',
      checkOut_Place_Order: 'تقديم الطلب',
      products_Items: 'مادة',
      app_notifications: 'إشعارات',
      app_notifications_settings: 'إعدادات الإشعارات',
      turn_on_notifications: 'تشغيل الإشعارات',
      notifications_type: 'نوع الإشعارات',
      notify_whatsapp: 'إشعارات واتساب',
      notify_app: 'إشعارات التطبيق',
      order_notification_Related: 'إشعارات متعلقة بالطلب',
      order_notification_Related_description: 'تحديثات حالة الطلب، المرتجعات والفواتير',
      product_stock_notification: 'إشعارات المنتج والمخزون',
      product_stock_notification_description: 'تنبيهات العودة إلى المخزون وإطلاق منتجات جديدة',
      promotions_Bonuses_notification: 'إشعارات العروض والمكافآت',
      promotions_Bonuses_notification_description: 'عروض المكافآت والصفقات',
      account_documents_notification: 'إشعارات الحساب والمستندات',
      account_documents_notification_description: 'عروض المكافآت والصفقات',
      critical_alert: 'تنبيه حرج',
      clitical_alert_description: 'استدعاء المنتج، مشاكل الحساب، وتذكيرات الدفع',
      order_confirmation: 'تأكيد الطلب',
      item_back_in_stock: 'العنصر متوفر مرة أخرى',
      limited_time_bonus_offers: 'عروض المكافآت لفترة محدودة',
      app_Best_Sellers: 'الأكثر مبيعًا',
      shop_home: 'الرئيسية',
      shop_screen: 'تسوق',
      shop_order: 'طلب',
      account_onHold: 'حسابك معلق',
      sales_rep: 'مندوب المبيعات',
      acc_hold_message: 'لن يتم شحن أو معالجة طلباتك. يرجى الاتصال بمندوب المبيعات الخاص بك.',
      cancel_order: 'إلغاء الطلب',
      cancel_order_msg: 'لقد طلبت إلغاء طلبك.',
      cancel_Question: 'هل أنت متأكد أنك تريد الإلغاء؟',
      shop_by_brand: 'تسوق حسب الماركة',
      view_all: 'عرض الكل',
      shop_by_category: 'تسوق حسب الفئة',
      desktop_cart: 'السلة',
      apply_filters: 'تطبيق',
      clear_checkOut: 'مسح',
      button_invoice: 'فاتورة',
      order_date: 'تاريخ الطلب',
      estimated_delivery: 'التوصيل المتوقع',
      awaiting_restock: 'في انتظار إعادة التخزين',
      cancel_order_failed: 'فشل إلغاء الطلب',
      qty_limit_reached: 'تم الوصول إلى الحد الأقصى للكمية',
      notes: 'ملاحظات'
    };
  }
};
